import { Alert, AlertTitle, Typography } from '@mui/material';
import { isNotNil } from 'ramda';
import { useTranslation } from 'react-i18next';

import { cancelledStatus, commentEnabledModes, DetailStatusProps } from '../NegotiationCaseDetailStatusWidget.types';
import { I18nNamespace } from '~/common/types';
import { Multiline } from '~/components/Multiline';
import { useSupplierComment } from '~/hooks';

export const CancelledStatus = ({
  negotiationCaseStatus,
  negotiatedQuote,
  supplierInteractionMode,
  cancellationReason,
  cancellationReasonText,
}: DetailStatusProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'NegotiationCaseDetailStatusWidget' });
  const { t: tCommon } = useTranslation();
  const { format } = useSupplierComment();
  const supplierComment = format(negotiatedQuote?.supplierComment);
  const commentEnabled = supplierInteractionMode && commentEnabledModes.includes(supplierInteractionMode);

  if (!cancelledStatus.includes(negotiationCaseStatus)) {
    return null;
  }

  const title = cancellationReason
    ? t('cancelled.titleWithReason', { reason: tCommon(`CaseCancellationReason.${cancellationReason}`) })
    : t('cancelled.title');

  return (
    <Alert severity="info">
      <AlertTitle>{title}</AlertTitle>
      <>
        {isNotNil(cancellationReasonText) && cancellationReasonText !== '' && (
          <Typography variant="body2">
            <Multiline>{t('cancelled.comment', { comment: cancellationReasonText })}</Multiline>
          </Typography>
        )}
        {commentEnabled && isNotNil(supplierComment) && (
          <Typography variant="body2">
            <Multiline>{t('cancelled.comment', { comment: supplierComment })}</Multiline>
          </Typography>
        )}
      </>
    </Alert>
  );
};
